module.exports = __webpack_public_path__ + "img/50n@2x.f5dcdd1b.svg";